import {
    DiAws,
    DiCss3,
    DiGithub,
    DiHtml5,
    DiJava,
    DiJavascript1,
    DiLinux,
    DiMongodb,
    DiNodejsSmall,
    DiPython,
    DiReact
} from 'react-icons/di';
import { FaCodeBranch, FaDatabase, FaExchangeAlt, FaRobot, FaUsers } from 'react-icons/fa';
import {
    SiAnsible,
    SiArgo,
    SiCloudflare,
    SiCsharp,
    SiDocker,
    SiDotnet,
    SiDatadog,
    SiGo,
    SiGooglecloud,
    SiGrafana,
    SiGraphql,
    SiHelm,
    SiJira,
    SiKubernetes,
    SiMicrosoftsqlserver,
    SiOpenai,
    SiPostman,
    SiPrometheus,
    SiSwift,
    SiTailwindcss,
    SiTerraform,
    SiTypescript
} from 'react-icons/si';
import { TbBrandNextjs } from 'react-icons/tb';

const dataArray = [
    {
        category: "Languages",
        items: [
            { language: "Go", description: "Used for DevOps automation and infrastructure workflows at UKG.", icon: <SiGo /> },
            { language: "Java", description: "Core computer science language from academic and project work.", icon: <DiJava /> },
            { language: "C#", description: "Built backend and frontend features for high-traffic production systems.", icon: <SiCsharp /> },
            { language: "JavaScript", description: "Frontend and Node.js development across web applications and tooling.", icon: <DiJavascript1 /> },
            { language: "TypeScript", description: "Used in full-stack Next.js work and typed web application development.", icon: <SiTypescript /> },
            { language: "Python", description: "Built RAG tooling, DNS automation, and Cloud/GCP integrations.", icon: <DiPython /> },
            { language: "Swift", description: "Listed in current technical skill set for application development.", icon: <SiSwift /> },
            { language: "SQL", description: "Analytics, reporting workflows, stored procedures, and data operations.", icon: <FaDatabase /> },
            { language: "HTML", description: "Semantic page structure for responsive web applications.", icon: <DiHtml5 /> },
            { language: "CSS", description: "Responsive styling with CSS frameworks and custom interfaces.", icon: <DiCss3 /> }
        ]
    },
    {
        category: "DevOps & Cloud",
        items: [
            { language: "Kubernetes", description: "Production platform operations and deployment reliability.", icon: <SiKubernetes /> },
            { language: "Docker", description: "Containerized application and service workflows.", icon: <SiDocker /> },
            { language: "Helm", description: "Managed Kubernetes release configuration and production deployments.", icon: <SiHelm /> },
            { language: "Terraform", description: "Infrastructure automation for repeatable cloud environments.", icon: <SiTerraform /> },
            { language: "Ansible", description: "Automated infrastructure and operational workflows.", icon: <SiAnsible /> },
            { language: "GitHub Actions", description: "Maintained CI/CD pipelines for large-scale payment platform releases.", icon: <DiGithub /> },
            { language: "ArgoCD", description: "GitOps-driven deployment monitoring and release workflows.", icon: <SiArgo /> },
            { language: "Grafana", description: "Production dashboards and monitoring for faster recovery.", icon: <SiGrafana /> },
            { language: "Prometheus", description: "Metrics collection and alerting for production infrastructure visibility.", icon: <SiPrometheus /> },
            { language: "Datadog", description: "Cloud monitoring and observability tooling for production systems.", icon: <SiDatadog /> },
            { language: "Google Cloud", description: "GCP integrations, service checks, RAG tools, and automation APIs.", icon: <SiGooglecloud /> },
            { language: "AWS", description: "Cloud deployment experience across scalable web application projects.", icon: <DiAws /> },
            { language: "Cloudflare", description: "DNS automation, API integrations, and web deployment workflows.", icon: <SiCloudflare /> }
        ]
    },
    {
        category: "Frameworks & Databases",
        items: [
            { language: ".NET", description: "Enterprise application development with C# and object-oriented design.", icon: <SiDotnet /> },
            { language: "Node.js", description: "Backend services, developer tooling, and automation workflows.", icon: <DiNodejsSmall /> },
            { language: "React", description: "Component-driven portfolio and web application development.", icon: <DiReact /> },
            { language: "Next.js", description: "Full-stack academic platform work with dynamic degree-path planning.", icon: <TbBrandNextjs /> },
            { language: "GraphQL", description: "API query language experience for structured data access patterns.", icon: <SiGraphql /> },
            { language: "Tailwind CSS", description: "Utility-first UI styling for responsive interfaces.", icon: <SiTailwindcss /> },
            { language: "SQL Server", description: "Stored procedures, analytics, reporting, and business data workflows.", icon: <SiMicrosoftsqlserver /> },
            { language: "MongoDB", description: "Document database used in full-stack academic planning projects.", icon: <DiMongodb /> },
            { language: "DynamoDB", description: "Listed in current database and cloud-oriented technical skill set.", icon: <FaDatabase /> }
        ]
    },
    {
        category: "Tools & AI",
        items: [
            { language: "Git & GitHub", description: "Version control, access automation, and GitHub-based developer workflows.", icon: <DiGithub /> },
            { language: "Postman", description: "API testing and REST workflow validation.", icon: <SiPostman /> },
            { language: "REST APIs", description: "Designed and integrated APIs for DNS automation and service workflows.", icon: <FaExchangeAlt /> },
            { language: "CI/CD", description: "Release automation supporting production systems with 3M+ users.", icon: <FaCodeBranch /> },
            { language: "Jira", description: "Agile issue tracking and delivery coordination across engineering teams.", icon: <SiJira /> },
            { language: "Vertex AI", description: "GCP AI tooling listed in current technical skill set.", icon: <SiGooglecloud /> },
            { language: "OpenAI APIs", description: "AI API integration experience from current tooling skill set.", icon: <SiOpenai /> },
            { language: "MCP Integrations", description: "Agent integration experience listed in current tooling skill set.", icon: <FaRobot /> },
            { language: "Agile", description: "Cross-functional collaboration with engineering and stakeholder teams.", icon: <FaUsers /> },
            { language: "Unix/Linux", description: "Command-line and Linux environment experience for engineering workflows.", icon: <DiLinux /> }
        ]
    }
];

export { dataArray };
